import { createContext, useState } from "react";

import Modal from "../components/Common/Modal";

const ModalContext = createContext({
  show: false,
  modalData: {},
  modalResponse: "",
  openModalHandler: () => {},
  closeModalHandler: () => {},
  clearModalResponse: () => {}
});

export default ModalContext;

export function ModalContextProvider({ children }) {
  const openModalHandler = (type, data, permissions) => {
    setModalContext((state) => ({
      ...state,
      show: true,
      modalData: { type, data, permissions }
    }));
  };

  const closeModalHandler = (modalType) => {
    setModalContext((state) => ({
      ...state,
      show: false,
      modalData: {},
      modalResponse: modalType
    }));
  };

  const clearModalResponse = () => {
    setModalContext((state) => ({
      ...state,
      modalResponse: ""
    }));
  };

  const [modalContext, setModalContext] = useState({
    show: false,
    modalData: {},
    openModalHandler,
    closeModalHandler,
    clearModalResponse,
    modalResponse: ""
  });

  return (
    <ModalContext.Provider value={modalContext}>
      {children}
      <ModalContext.Consumer>
        {({ show, modalData, clearModalResponse, closeModalHandler }) => (
          <Modal
            show={show}
            modalData={modalData}
            closeModal={closeModalHandler}
            clearResponse={clearModalResponse}
          />
        )}
      </ModalContext.Consumer>
    </ModalContext.Provider>
  );
}
